import { lang } from "../provider";

/**
 * Returns i18n for Prometheus PageHeader v1 component.
 */
export function getPageHeaderI18n() {
    return {
        breadcrumbLabel: lang.main("Breadcrumb_NavigationLabel"),
        present: lang.page("Present"),
        showMoreOptions: lang.main("Functions"),
        skipLink: lang.main("Breadcrumb_SkipLinkLabel"),
        stopPresent: lang.page("Stop_presenting"),
    }
}
